module.exports = __webpack_public_path__ + "img/c4a1af2.jpg";